import { apiConnector } from "../apiConnector";
import { settingsEndpoints } from "../api";

export const getSettings = async () => {
    try {
        const response = await apiConnector("GET", settingsEndpoints.GET_SETTINGS);
        if (!response.data.success) {
            throw new Error(response.data.message);
        }
        return response.data;
    } catch (error) {
        console.log("GET_SETTINGS API ERROR............", error);
        return error.response?.data || { success: false, message: error.message };
    }
};

export const updateSettings = async (data) => {
    try {
        const response = await apiConnector("PUT", settingsEndpoints.UPDATE_SETTINGS, data);
        if (!response.data.success) {
            throw new Error(response.data.message);
        }
        return response.data;
    } catch (error) {
        console.log("UPDATE_SETTINGS API ERROR............", error);
        return error.response?.data || { success: false, message: error.message };
    }
};
